/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";

/**
 * Severity of an alarm.
 */
export const AlarmSeverityLevel = {
  Critical: "critical",
  Warning: "warning",
  Caution: "caution",
} as const;
/**
 * Severity of an alarm.
 */
export type AlarmSeverityLevel = OpenEnum<typeof AlarmSeverityLevel>;

/** @internal */
export const AlarmSeverityLevel$inboundSchema: z.ZodType<
  AlarmSeverityLevel,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(AlarmSeverityLevel);
/** @internal */
export const AlarmSeverityLevel$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  AlarmSeverityLevel
> = openEnums.outboundSchema(AlarmSeverityLevel);
